export default [
  {
    name: 'signin',
    path: '/signin',
    meta: {
      requireSignin: false,
      layout: 'DefaultLayout',
      design: { classes: ['fill-height', 'bg--linear-gradient'] },
    },

    component: () => import('@/pages/signin/Signin.vue'),
  },
]
